import store from '~/store';

function getActiveStoreId() {
  /**
   * Temporary solution, until multistores will be delivered
   */
  if (!store.getters['auth/activeStore']) {
    return null;

    throw {
      message: 'Please add your store first',
    };
  }

  return store.getters['auth/activeStore'].id;
}

const findProductsRoutes = {
  productList: 'api/product',
  importList: 'api/stores/{storeId}/import-lists',
  removeFromImportList: 'api/stores/{storeId}/products/remove-from-user-import-list',
  addToImportList: '/api/stores/{storeId}/products/add-to-import-list',
  suppliers: 'api/suppliers/visible',
};

const productDetailRoutes = {
  importList: findProductsRoutes.importList,
  removeFromImportList: findProductsRoutes.removeFromImportList,
  addToImportList: findProductsRoutes.addToImportList,
};

const trendingProductsRoutes = {
  productList: 'api/get-trending-products',
  importList: findProductsRoutes.importList,
  removeFromImportList: findProductsRoutes.removeFromImportList,
  addToImportList: findProductsRoutes.addToImportList,
  suppliers: findProductsRoutes.suppliers,
};

const storeRoutes = {
  storeList: 'api/stores',
  store: 'api/stores/{storeId}',
};

export const Routes = {
  findProducts: findProductsRoutes,
  productDetail: productDetailRoutes,
  getProductStats: (productId) => `/api/products/${productId}/stats`,
  asyncRequestStatus: '/api/async-request/status',
  trendingProducts: trendingProductsRoutes,
  stores: storeRoutes,
  common: {
    config: 'api/user/config',
  },
  onboarding: {
    getProductCategories: (storeId) => `/api/stores/${storeId}/onboarding/products/categories`,
    getProductsFromCategories: (storeId) => `/api/stores/${storeId}/onboarding/products`,
    addToImportList: (storeId) => `/api/stores/${storeId}/onboarding/products/add-to-import-list`,
    importToStore: (storeId) => `/api/stores/${storeId}/onboarding/products/import-to-store`,
    getCategories: 'api/onboarding/categories',
    getProducts: 'api/onboarding/products',
    setupStore: (storeId) => `/api/stores/${storeId}/onboarding/setup`,
    trackProgress: '/api/onboarding/track-progress',
    deal: '/api/onboarding/deal',
  },
  printfulCatalog: {
    catalogBase: '/catalog',
    categories: 'api/pod/catalog/category',
    collections: 'api/pod/catalog',
    categoryProducts(id) {
      return `api/pod/catalog/category/${id}/product`;
    },
    categoryProductsByPage(id, page) {
      return `api/pod/catalog/category/${id}/product?page=${page}`;
    },
    nonceToken: 'api/pod/edm/create-nonce-token',
    updateNonceToken: 'api/pod/edm/update-nonce-token',
    saveTemplate: 'api/pod/template',
  },
  printfulTemplates: {
    templatesMainPage: '/templates',
    templatesData: (storeId) => `api/pod/template/${storeId}`,
    templatesDataByPage(page, storeId) {
      return `api/pod/template/{storeId}?page=${page}`;
    },
    deleteTemplate(uuid) {
      return `api/pod/template/${uuid}`;
    },

    updateTemplate(uuid) {
      return `api/pod/template/${uuid}`;
    },
  },
  linkProduct: {
    getOrdersCountForStoreProduct: () => `api/stores/${getActiveStoreId()}/store-products/orders-count`,
    processProductLinking: () => `api/stores/${getActiveStoreId()}/process-product-linking`,
    processBundleLinking: () => `api/stores/${getActiveStoreId()}/process-bundle-linking`,
    overrideProduct: () => `api/stores/${getActiveStoreId()}/override-product`,
  },
  myStores: {
    storeList: 'api/stores',
    store: (id) => `api/stores/${id}`,
    storeListUrls: 'api/connect-stores-list',
    validateStoreUrl: 'api/validate-store-url',
    claimStore: 'api/store/unclaimed/claim',
    checkShippingTemplate: 'api/tiktok/stores/{storeId}/check-shipping-template',
    patchMainStoreSettings: () => `/api/stores/${getActiveStoreId()}/store-settings`,
    updateFulfillmentSettings: () => `/api/stores/${getActiveStoreId()}/fulfillment-settings`,
  },
  tiktok: {
    fetchCategories: () => `api/tiktok/stores/${getActiveStoreId()}/categories`,
    fetchWarehouses: () => `api/stores/${getActiveStoreId()}/warehouses`,
    fetchSuggestedCollections: () => `api/tiktok/stores/${getActiveStoreId()}/categories/recommended`,
    patchWarehouse: (data) => `/api/stores/${getActiveStoreId()}/locations/${data.warehouseId}`,
  },
  shipping: {
    fetchStructure: 'api/shipping-structure',
  },
  userPlan: {
    promotionalCredits: 'api/billing/user-credits/balance/promotional',
    sendFeedback: 'api/user/plan/feedback',
    downgradeDeal: 'api/user/plan/downgrade-deal',
    getPlanPriceList: 'api/get-plans-price-list',
    notifyForVisitingPlan: 'api/notify-for-visiting-plan-page',
  },
  userProfile: {
    updatePassword: 'api/update-password',
    attemptToLoginAsReviwer: 'api/attempt-to-login-as-review-app-user',
    user: 'api/user',
    logout: 'api/auth/logout',
    fetchOauthUrl: (provider) => `/api/oauth/${provider}`,
    getUserCredit: 'api/user-credit-amount-left',
    loginAsAdmin: 'api/login-as-admin',
    updateUserSettings: 'api/update-user-setting',
    setPassword: 'api/set-password',
    getInvoicedMonth: 'api/get-invoiced-month',
    getInvoice: 'api/get-invoice',
    updateUser: 'api/user',
    updateBillingSettings: {
      togglePromoCreditsUseByDefault: (value) =>
        value === true
          ? '/api/billing-settings/enable-use-promo-credits-by-default'
          : '/api/billing-settings/disable-use-promo-credits-by-default',
    },
  },
  payment: {
    getPaymentMethodSetup: 'api/get-payment-method-setup-intent',
    createOrUpdateSubscription: 'api/create-or-update-subscription',
    addOrUpdateBillingInfo: 'api/add-or-update-billing-info',
    getUserSubscriptions: 'api/get-user-subscriptions',
    createCreditCard: 'api/credit-card/create',
    createPaypalOrder: 'api/paypal/create-order',
    capturePaypalPayment: 'api/paypal/capture-payment',
    checkPaymentStatus: 'api/check-payment-status',
    deletePaymentMethod: 'api/delete-payment-method',
    setDefaultPaymentMEthod: 'api/set-default-payment-method',
  },
  order: {
    getOrdersCost: () => `api/stores/${getActiveStoreId()}/orders/cost`,
    getOrdersAsyncCost: () => `api/stores/${getActiveStoreId()}/orders/async-cost`,
    getFulfillmentPaymentOptions: () => `api/stores/${getActiveStoreId()}/orders/fulfillment-payment-options`,
    getOrdersStatistic: () => `api/stores/${getActiveStoreId()}/orders/statistic`,
    getOrdersExport: () => `api/stores/${getActiveStoreId()}/orders/export`,
    getOrders: () => `/api/stores/${getActiveStoreId()}/orders`,
    getOrdersIssues: () => `/api/stores/${getActiveStoreId()}/orders/issues`,
    createIssue: () => `/api/stores/${getActiveStoreId()}/orders/issues`,
    getOrderIssue: (issueId) => `/api/stores/${getActiveStoreId()}/orders/issues/${issueId}`,
    agreeIssueSolution: (issueId) => `/api/stores/${getActiveStoreId()}/orders/issues/${issueId}/agree-solution`,
    confirmOrder: (issueId) => `/api/stores/${getActiveStoreId()}/orders/issues/${issueId}/confirm-order`,
    cancelAndRefund: (issueId) => `/api/stores/${getActiveStoreId()}/orders/issues/${issueId}/cancel-and-refund`,
    trackAction: (issueId) => `/api/stores/${getActiveStoreId()}/orders/issues/${issueId}/track-action`,
    getOrder: (orderId) => `/api/stores/${getActiveStoreId()}/orders/${orderId}`,
    getOrdersCount: () => `api/stores/${getActiveStoreId()}/orders/count`,
    cancelOrderItems: () => `api/stores/${getActiveStoreId()}/orders/line-items/cancel`,
    getOrderShipCountriesList: () => `api/stores/${getActiveStoreId()}/orders/ship-countries`,
    getOrderProducts: () => `api/stores/${getActiveStoreId()}/orders/products`,
    updateShippingAddress: () => `api/stores/${getActiveStoreId()}/orders/update-shipping-address`,
    getConfirmVariantsOrder: () => `api/stores/${getActiveStoreId()}/orders/get-confirm-variants-order`,
    updateOrderData: () => `api/stores/${getActiveStoreId()}/orders/update-data`,
    placeOrder: () => `api/stores/${getActiveStoreId()}/orders/sample-orders`,
    requestForQuotation: 'api/request-for-quotation',
    fulfillOnPlatform: (orderId) => `/api/stores/${getActiveStoreId()}/orders/${orderId}/fulfill-on-platform`,
    importList: (importListId) => `api/stores/${getActiveStoreId()}/import-lists/${importListId}`,
    downloadOrdersCSV: () => `/api/stores/${getActiveStoreId()}/orders/export-csv`,
    getExternalOrders: () => `/api/stores/${getActiveStoreId()}/orders`,
  },
  other: {
    recordProductClick: 'api/record-product-click-event',
    getCountries: 'api/get-countries',
    seenFirstOrderModal: 'api/seen-first-order-modal',
    ackonwledgeQuote: 'api/acknowledge-quote',
    getDashboardData: (params) => `/api/stores/${getActiveStoreId()}/dashboard-data?range=${params.range}`,
    getDashboardOverviewData: (range) => `/api/stores/${getActiveStoreId()}/dashboard-overview-data?range=${range}`,
    contactUs: 'api/contactus',

    // New ORDERS FULFILLMENT APIs
    checkFulfillmentStatus: (storeId) => `/api/async-request/get-pending?storeId=${storeId}`,
    checkFulfillmentStatusByOrderId: '/api/async-request/status',
    postFulfillmentRequest: (storeId) => `/api/stores/${storeId}/orders/fulfill-line-items`,
  },
  branding: {
    updateBrandingSettings: () => `/api/stores/${getActiveStoreId()}/branding-settings`,
    updateCustomBrandingData: () => `/api/stores/${getActiveStoreId()}/custom-branding-data`,
  },
  products: {
    products: '/api/product',
    removeFromImportList: () => `api/stores/${getActiveStoreId()}/products/remove-from-user-import-list`,
    removeBundleFromImportList: () => `api/stores/${getActiveStoreId()}/products/remove-from-import-list`,
    importProductToStore: () => `api/stores/${getActiveStoreId()}/products/import`,
    importBundleToStore: () => `api/stores/${getActiveStoreId()}/import-bundle`,
    importSubscriptionToStore: () => `api/stores/${getActiveStoreId()}/import-subscription`,
    addToImportList: () => `api/stores/${getActiveStoreId()}/products/add-to-import-list`,
    getSimilarProducts: 'api/get-similar-product',
    getSubscriptionBoxData: 'api/get-subscription-box-data',
    submitProductForQuote: (storeProductId) =>
      `api/stores/${getActiveStoreId()}/store-products/${storeProductId}/quote`,
    fetchShopifyProductDetails: (storeProductId) =>
      `api/stores/${getActiveStoreId()}/store-products/${storeProductId}/details`,
    getSingleImportList: () => `api/stores/${getActiveStoreId()}/get-single-import-list`,
    getStoreProductsIssuesCount: () => `api/stores/${getActiveStoreId()}/store-products/issues-count`,
    dontLinkProduct: () => `api/stores/${getActiveStoreId()}/store-products/ignore`,
    undoIgnoredProduct: () => `api/stores/${getActiveStoreId()}/store-products/restore-ignored`,
    getProductCarousel: 'api/get-product-carousel',
    getProductMeta: 'api/meta-data-product-page',
    getTrendingProducts: 'api/get-trending-products',
    fetchAliexpressImportedProductByUrl: 'api/fetch-aliexpress-imported-products-by-url',
    getCollectionsAndCategories: () => `api/stores/${getActiveStoreId()}/get-collections-and-categories`,
    importListProducts: () => `api/stores/${getActiveStoreId()}/import-lists`,
    storeListProducts: () => `api/stores/${getActiveStoreId()}/store-products`,
    getProduct: 'api/get-product',
    updateProductNotification: 'api/update-product-notification',
    createBundle: 'api/create-bundle',
    updateBundle: 'api/update-bundle',
    searchProductByKeyword: 'api/search-product-by-keyword',
    updateBundleSubscription: 'api/update-bundle-subscription',
    saveBundleSubscription: 'api/save-bundle-subscription',
    searchExistingProduct: () => `api/stores/${getActiveStoreId()}/search-existing-product`,
    updateVariantMapping: () => `api/stores/${getActiveStoreId()}/update-variant-mappings`,
    fetchProductVariants: (productId) => `/api/products/${productId}/variants`,
    fetchVariantMappings: (importListId) =>
      `/api/stores/${getActiveStoreId()}/import-lists/${importListId}/variant-mappings`,
    getSubscriptionBoxes: 'api/get-subscription-boxes',
    getBundleProducts: 'api/get-bundle-products',
    removeSubscriptionBox: () => `api/stores/${getActiveStoreId()}/remove-subscription-box`,
    addSubscriptionBoxToImportList: () => `api/stores/${getActiveStoreId()}/import-lists/add-subscription-box`,
    removeSubscriptionBoxFromImport: () => `api/stores/${getActiveStoreId()}/import-lists/remove-subscription-box`,
    unlinkProduct: (importListId) => `api/stores/${getActiveStoreId()}/import-lists/${importListId}`,
    removeBundleBox: 'api/remove-bundle-product',
    addBundleToImportList: () => `api/stores/${getActiveStoreId()}/add-bundle-to-import-list`,
    removeBundleFromImport: 'api/remove-bundle-from-import-list',
    bundleSampleOrder: () => `/api/stores/${getActiveStoreId()}/orders/bundle-sample-orders`,
    getSourcingRequests: 'api/user/sourcing-requests',
    createSourcingRequests: 'api/user/sourcing-requests',
    getRelatedProducts: '/api/related-products',
  },

  shipment: {
    estimateProductShipment: '/api/shipping/estimate-product',
    estimateBundleShipment: '/api/shipping/estimate-bundle-product',
  },

  zendropAI: {
    issueTemporaryToken: '/api/issue-temporary-token',
  },

  trial: {
    freeTrial: 'api/free-trial',
  },
  verification: {
    sendVerificationCode: '/api/phone-verification/send',
    sendEmailVerificationCode: '/api/auth/otp-resend',
    checkVerificationCode: '/api/phone-verification/verify',
  },
  accessTokens: {
    list: '/api/access-tokens',
    create: '/api/access-tokens',
    revoke: (id) => `/api/access-tokens/${id}`,
  },
  tracking: {
    hubSpotTrackFeatureAccess: '/api/track',
  },
};
